import * as constants from '../constants';

export function openSelectLanguageDialog(isOpen) {
    return {
        type: constants.ACTION_TYPE_TOP_MENU__OPEN_SELECT_LANGUAGE_DIALOG,
        data: { isOpen }
    };
}